import React from 'react';

const QUICK_LINKS = [
  {
    href: 'https://lookerstudio.google.com/u/0/reporting/7f2be3ab-1a8a-4ab2-9129-45e70d331e3b/page/k1BTD',
    title: 'Dashboard Compania'
  },
  {
    href: 'https://lookerstudio.google.com/u/0/reporting/49a417f1-2d49-4ce0-a608-d24c652ef12c/page/k1BTD',
    title: 'Dashboard KRs'
  },
  {
    href: 'https://sites.google.com/tomi.digital/wiki/inicio?authuser=0',
    title: 'Wiki de la organizacion'
  }
];

const QuickLinks = ({ className = 'quick-links-list' }) => {
  return (
    <div className={className}>
      {QUICK_LINKS.map((link) => (
        <a
          key={link.href}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="quick-links-list__item"
        >
          {link.title}
        </a>
      ))}
    </div>
  );
};

export default QuickLinks;